/**
 * App Store links and mobile device detection helpers
 */

export const APP_STORE_LINKS = {
  APPLE_APP_STORE: 'https://apps.apple.com/in/app/fixome-home-services/id6793360580',
  GOOGLE_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.anaval.fixome',
  APPLE_APP_ID: '6793360580',
  ANDROID_PACKAGE: 'com.anaval.fixome',
};

/**
 * Detect client mobile operating system
 * @returns {'ios' | 'android' | 'other'}
 */
export const detectMobileOS = () => {
  if (typeof window === 'undefined') return 'other';
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  return 'other';
};

/**
 * Get the direct store link based on device OS
 * @returns {string}
 */
export const getDeviceStoreUrl = () => {
  const os = detectMobileOS();
  if (os === 'ios') return APP_STORE_LINKS.APPLE_APP_STORE;
  if (os === 'android') return APP_STORE_LINKS.GOOGLE_PLAY_STORE;
  return APP_STORE_LINKS.GOOGLE_PLAY_STORE; // default fallback
};
